import { render, staticRenderFns } from "./castProfile.vue?vue&type=template&id=74e69fe9&scoped=true&"
import script from "./castProfile.vue?vue&type=script&lang=js&"
export * from "./castProfile.vue?vue&type=script&lang=js&"
import style0 from "./castProfile.vue?vue&type=style&index=0&id=74e69fe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e69fe9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
